import { Building2, X } from "lucide-react";
import { useTransportadora, formatCNPJ } from "@/contexts/TransportadoraContext";

/**
 * Banner que aparece em todas as páginas quando há uma transportadora selecionada
 * (filtro global ativo). Permite limpar o filtro rapidamente.
 */
export const TransportadoraBanner = () => {
  const { selectedCnpj, selectedTransp, setSelectedCnpj } = useTransportadora();

  if (!selectedCnpj || !selectedTransp) return null;

  const clear = () => {
    setSelectedCnpj("");
    window.location.reload();
  };

  return (
    <div
      data-testid="transp-banner"
      className="mb-6 flex items-center justify-between gap-3 px-4 py-2.5 bg-[#09090B] text-white rounded-md"
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Building2 size={14} className="shrink-0" />
        <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-400">
          Filtro ativo
        </span>
        <span className="text-sm font-semibold truncate">{selectedTransp.nome}</span>
        <span className="text-[11px] font-mono-data text-zinc-400 hidden md:inline">
          {formatCNPJ(selectedCnpj)}
        </span>
      </div>
      <button
        data-testid="transp-banner-clear"
        onClick={clear}
        className="flex items-center gap-1 px-3 py-1 text-xs text-zinc-300 hover:text-white hover:bg-[#27272A] rounded-sm transition-colors"
      >
        <X size={12} />
        Limpar
      </button>
    </div>
  );
};

export default TransportadoraBanner;
